module.exports = __webpack_public_path__ + "media/images/es/logo-ocu-white-d44fda381098139bddeebf87de969c2e.png";